<template>
    <div id="app-layout">
        <main>
            <slot />
        </main>
        <NavigationBar />
    </div>
</template>

<script lang="ts" setup>
import NavigationBar from "@/components/navigationBar/NavigationBar.vue";
</script>

<style lang="scss" scoped>
#app-layout {
    display: flex;
    flex-direction: column;
    min-height: 100dvh;
    background-color: #f5f5f5;

    padding: 28px 20px calc(var(--nav-height) + 28px);
    @media (max-width: 375px) {
        padding: 20px 16px calc(var(--nav-height) + 20px);
    }

    main {
        min-height: 0;
        flex: 1;
    }
}
</style>
